import { render, staticRenderFns } from "./answer_mode.vue?vue&type=template&id=6798e28e&scoped=true"
import script from "./answer_mode.vue?vue&type=script&lang=js"
export * from "./answer_mode.vue?vue&type=script&lang=js"
import style0 from "./answer_mode.vue?vue&type=style&index=0&id=6798e28e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798e28e",
  null
  
)

export default component.exports